<template>
  <div class="currency_box">
    <div class="img_box"
         @click="toActivity(list[activeIndex])">
      <el-image style="width:100%;height:100%;border-radius: 10px;"
                :src="list[activeIndex].bannerUrl"></el-image>
      <div class="bottom_title">
        {{list[activeIndex].activityName}}
      </div>
    </div>
    <div class="content_box">
      <div :class="activeIndex==index?'activecontent_item':'content_item'"
           v-for="(item,index) in list"
           :key="index"
           @click="itemClick(item,index)">
        <div class="title"> <span :class="activeIndex == index?'mainColor':''">{{item.activityState | activityStateType}}</span>·{{item.activityName}}</div>
        <div style="color:#666;font-size:14px;margin:10px 0">时间：{{item.startTimeShort +'至'+item.endTimeShort}}</div>
        <div style="color:#666;font-size:14px;margin-bottom: 10px;"
             v-if="item.courseClassify == '1'">地点：{{item.areaStr}}</div>
        <div style="color:#666;font-size:12px">{{item.introduce}}</div>
      </div>
      <!-- <ul class="infinite-list"
          v-infinite-scroll="load"
          style="overflow:auto">
        <li v-for="i in count"
            class="infinite-list-item">{{ i }}</li>
      </ul> -->
    </div>
  </div>
</template>
<script>
export default {
  filters: {
    activityStateType (val) {
      let text = "";
      switch (val) {
        case 1:
          text = '未开始';
          break
        case 2:
          text = '进行中';
          break
        case 3:
          text = '已结束';
          break
      }
      return text
    }
  },
  props: {
    list: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  data () {
    return {
      activeIndex: 0,
      count: 50
    }
  },
  methods: {
    itemClick (item, index) {
      this.activeIndex = index
    },
    toActivity (item) {
      this.$router.push('/Activity?id=' + item.id)
    }
  }

}
</script>
<style lang="less" scoped>
.img_box {
  cursor: pointer;
  width: 773px;
  height: 440px;
  background-color: #eee;
  border-radius: 10px;
  margin-right: 20px;
  position: relative;
  .bottom_title {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 80px;
    width: 100%;
    border-radius: 0 0 10px 10px;
    padding: 0 20px;
    box-sizing: border-box;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.content_box {
  flex: 1;
  height: 440px;
  overflow-y: auto;
  padding-right: 10px;
  .activecontent_item {
    background: #ffe9e9;
    border-radius: 10px;
    padding: 16px 13.5px;
    // box-sizing: border-box;
    cursor: pointer;
    margin-bottom: 20px;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #000;
    }
  }
  .content_item {
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 15px 12.5px;
    box-sizing: border-box;
    margin-bottom: 20px;
    .title {
      font-weight: bold;
      color: #000;
      font-size: 16px;
    }
  }
}
</style>